module.exports = __webpack_public_path__ + "static/media/country_gf.b17e6245.webp";